import { Fund, Funds } from "./types";

export function groupFundsByType(funds: Fund[]) {
  return funds.reduce((result, currentItem) => {
    result[currentItem.fund_type] = result[currentItem.fund_type] || [];
    result[currentItem.fund_type].push(currentItem);

    return result;
  }, {} as Funds);
}
